import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    getJobs,
    addJOb,
    editJob,
    deleteJob

} from "./jobAPI";

const initialState = {
    jobs: [],
    isLoading: false,
    isError: false,
    error: "",
    editing: {},
};

// async thunks
export const fetchJobs = createAsyncThunk(
    "jobs/fetch",
    async () => {
        const jobs = await getJobs();
        return jobs;
    }
);

export const createJob = createAsyncThunk(
    "jobs/create",
    async (data) => {
        const job = await addJOb(data);
        return job;
    }
);

export const changeJob = createAsyncThunk(
    "job/edit",
    async ({ id, data }) => {
        const job = await editJob(id, data);
        return job;
    }
);

export const removeJob = createAsyncThunk(
    "job/remove",
    async (id) => {
        const job = await deleteJob(id);
        return job;
    }
);

// create slice
const jobsSlice = createSlice({
    name: "job",
    initialState,
    reducers: {
        editActive: (state, action) => {
            state.editing = action.payload;
        },
        editInActive: (state) => {
            state.editing = {};
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchJobs.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(fetchJobs.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.jobs = action.payload;
            })
            .addCase(fetchJobs.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
                state.jobs = [];
            })
            .addCase(createJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(createJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;
                state.jobs.push(action.payload);
            })
            .addCase(createJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(changeJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(changeJob.fulfilled, (state, action) => {
                state.isError = false;
                state.isLoading = false;

                const indexToUpdate = state.jobs.findIndex(
                    (job) => job.id === action.payload.id
                );

                state.jobs[indexToUpdate] = action.payload;
            })
            .addCase(changeJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            })
            .addCase(removeJob.pending, (state) => {
                state.isError = false;
                state.isLoading = true;
            })
            .addCase(removeJob.fulfilled, (state, action) => {
                console.log(action);
                state.isError = false;
                state.isLoading = false;

                state.jobs = state.jobs.filter(
                    (job) => job.id !== action.meta.arg
                );
            })
            .addCase(removeJob.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.error = action.error?.message;
            });
    },
});

export default jobsSlice.reducer;
export const { editActive, editInActive } = jobsSlice.actions;